import { render } from "./ecormmerceIncome.vue?vue&type=template&id=274bcb88"
import script from "./ecormmerceIncome.vue?vue&type=script&lang=js"
export * from "./ecormmerceIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__